<button type="button">
  <i class="material-icons add">add_circle</i>
  <ng-content></ng-content>
  <i class="material-icons chevron">chevron_right</i>
</button>
